module.exports = {"610404001":"中山街街道","610404002":"文汇路街道","610404003":"新兴路街道","610404004":"渭阳街道","610404005":"渭城街道","610404006":"窑店街道","610404007":"正阳街道","610404008":"周陵街道","610404009":"底张街道","610404010":"北杜街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610404.json
// module id = 2808
// module chunks = 0